module.exports = __webpack_public_path__ + "img/logo-aivoni-newgen-blue.34e10736.png";